import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=726f7db5&scoped=true"
import script from "./RoleTable.vue?vue&type=script&lang=js"
export * from "./RoleTable.vue?vue&type=script&lang=js"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=726f7db5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f7db5",
  null
  
)

export default component.exports